import React from "react";
import "./style.css";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";

export const BillingDaily = ({ data }) => {
    return (
        <Card style={{borderRadius:"0px"}}>
            <Card.Header>
                <Card.Title>Daily</Card.Title>
            </Card.Header>
            <Card.Body>
                <Card.Text>
                    {!!data?.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">App</th>
                                    <th scope="col">Method</th>
                                    <th scope="col">Count</th>
                                    <th scope="col">Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((o, index) =>
                                    o?.estimation.map((e, eIndex) => (
                                        <tr>
                                            <td>{o?.app}</td>
                                            <td>{e?.method}</td>
                                            <td>{e?.count}</td>
                                            <td>{e?.cost}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    ) : (
                        <div>No billing data found</div>
                    )}
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

